// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SensorGrid.css */
.sensor-grid-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.sensor-grid {
  height: calc(100% - 60px);
}

/* 스크롤 모드 */
.sensor-grid-container.scroll .sensor-grid {
  height: calc(100% - 60px); /* 페이지네이션과 동일한 높이 */
}

/* 그리드 셀 중앙 정렬 */
.sensor-grid .rdg-cell {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

.sensor-grid .rdg-header-cell {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}

.no-result-container {
  height: 600px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.no-result-content {
  text-align: center;
  color: #6c757d;
  font-size: 18px;
}

.no-result-icon {
  margin-bottom: 10px;
  font-size: 48px;
}

.no-result-subtitle {
  font-size: 14px;
  margin-top: 5px;
}

.status-pass {
  color: green;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #f0f8f0;
}

.status-fail {
  color: red;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #fff0f0;
}

.pagination-container {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.pagination-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination-select {
  padding: 4px 8px;
}

.pagination-info {
  margin-left: 20px;
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 5px;
}

.pagination-container .pagination-button {
  padding: 6px 12px !important;
  border: 1px solid #ccc !important;
  background-color: white !important;
  cursor: pointer !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  color: #333 !important;
}

.pagination-container .pagination-button:disabled {
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
  color: #999 !important;
}

.pagination-container .pagination-button:hover:not(:disabled) {
  background-color: #e9ecef !important;
}

.pagination-current {
  margin: 0 10px;
}

/* 다크모드 */
[data-theme="dark"] .no-result-container {
  background-color: #1a1a1a;
  border-color: #404040;
  color: #ffffff;
}

[data-theme="dark"] .no-result-content {
  color: #ffffff;
}

[data-theme="dark"] .pagination-container {
  background-color: #2d2d2d;
  border-top-color: #404040;
  color: #ffffff;
}

[data-theme="dark"] .pagination-container .pagination-button {
  background-color: #404040 !important;
  border-color: #666 !important;
  color: #ffffff !important;
}

[data-theme="dark"] .pagination-container .pagination-button:disabled {
  background-color: #2d2d2d !important;
  color: #666 !important;
}

[data-theme="dark"] .pagination-container .pagination-button:hover:not(:disabled) {
  background-color: #555 !important;
}

[data-theme="dark"] .pagination-select {
  background-color: #404040;
  border-color: #666;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/SensorGrid.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* SensorGrid.css */\r\n.sensor-grid-container {\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.sensor-grid {\r\n  height: calc(100% - 60px);\r\n}\r\n\r\n/* 스크롤 모드 */\r\n.sensor-grid-container.scroll .sensor-grid {\r\n  height: calc(100% - 60px); /* 페이지네이션과 동일한 높이 */\r\n}\r\n\r\n/* 그리드 셀 중앙 정렬 */\r\n.sensor-grid .rdg-cell {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.sensor-grid .rdg-header-cell {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.no-result-container {\r\n  height: 600px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n}\r\n\r\n.no-result-content {\r\n  text-align: center;\r\n  color: #6c757d;\r\n  font-size: 18px;\r\n}\r\n\r\n.no-result-icon {\r\n  margin-bottom: 10px;\r\n  font-size: 48px;\r\n}\r\n\r\n.no-result-subtitle {\r\n  font-size: 14px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.status-pass {\r\n  color: green;\r\n  font-weight: bold;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  background-color: #f0f8f0;\r\n}\r\n\r\n.status-fail {\r\n  color: red;\r\n  font-weight: bold;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  background-color: #fff0f0;\r\n}\r\n\r\n.pagination-container {\r\n  height: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 16px;\r\n  border-top: 1px solid #dee2e6;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.pagination-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.pagination-select {\r\n  padding: 4px 8px;\r\n}\r\n\r\n.pagination-info {\r\n  margin-left: 20px;\r\n}\r\n\r\n.pagination-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.pagination-container .pagination-button {\r\n  padding: 6px 12px !important;\r\n  border: 1px solid #ccc !important;\r\n  background-color: white !important;\r\n  cursor: pointer !important;\r\n  border-radius: 4px !important;\r\n  font-size: 14px !important;\r\n  color: #333 !important;\r\n}\r\n\r\n.pagination-container .pagination-button:disabled {\r\n  background-color: #f5f5f5 !important;\r\n  cursor: not-allowed !important;\r\n  color: #999 !important;\r\n}\r\n\r\n.pagination-container .pagination-button:hover:not(:disabled) {\r\n  background-color: #e9ecef !important;\r\n}\r\n\r\n.pagination-current {\r\n  margin: 0 10px;\r\n}\r\n\r\n/* 다크모드 */\r\n[data-theme=\"dark\"] .no-result-container {\r\n  background-color: #1a1a1a;\r\n  border-color: #404040;\r\n  color: #ffffff;\r\n}\r\n\r\n[data-theme=\"dark\"] .no-result-content {\r\n  color: #ffffff;\r\n}\r\n\r\n[data-theme=\"dark\"] .pagination-container {\r\n  background-color: #2d2d2d;\r\n  border-top-color: #404040;\r\n  color: #ffffff;\r\n}\r\n\r\n[data-theme=\"dark\"] .pagination-container .pagination-button {\r\n  background-color: #404040 !important;\r\n  border-color: #666 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n[data-theme=\"dark\"] .pagination-container .pagination-button:disabled {\r\n  background-color: #2d2d2d !important;\r\n  color: #666 !important;\r\n}\r\n\r\n[data-theme=\"dark\"] .pagination-container .pagination-button:hover:not(:disabled) {\r\n  background-color: #555 !important;\r\n}\r\n\r\n[data-theme=\"dark\"] .pagination-select {\r\n  background-color: #404040;\r\n  border-color: #666;\r\n  color: #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
